import { NoResults } from "../../../../components/NoResults/NoResults.js";
import { useTabsState } from "../../../../hooks/useTabsState.js";
import { useLocationContext } from "../../contexts/LocationContext.js";
import { useInfoBlockCategoriesForLocation } from "../../hooks/useInfoBlockCategoriesForLocation.js";
import { ContactsList } from "./Contacts/index.js";
import { LocationInfoBlocksList } from "./components/LocationInfoBlocksList.js";
import "react";
import { ColorSquare, Loading, Tabs } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Locations/shared/LocationInfo/LocationInfoTabs.tsx
function LocationInfoTabs() {
	const { location, locationId } = useLocationContext(true);
	const [tab, setTab] = useTabsState(`info-tab-${locationId}`, `contacts`);
	const { data, loading } = useInfoBlockCategoriesForLocation({ locationId });
	return /* @__PURE__ */ jsxs("div", {
		className: "relative",
		children: [
			loading && /* @__PURE__ */ jsx(Loading, { overlay: true }),
			!location?.info.contacts && !data?.infoBlockCategories.length && /* @__PURE__ */ jsx(NoResults, { text: "No Contacts & Info" }),
			/* @__PURE__ */ jsxs(Tabs, {
				initialTabKey: tab,
				onTabClick: setTab,
				pills: true,
				children: [!!location?.info.contacts && /* @__PURE__ */ jsx(Tabs.Tab, {
					tabKey: "contacts",
					title: "Contacts",
					children: /* @__PURE__ */ jsx(ContactsList, {})
				}), data?.infoBlockCategories?.map((category) => /* @__PURE__ */ jsx(Tabs.Tab, {
					tabKey: category.id,
					title: /* @__PURE__ */ jsxs("span", { children: [category.color && /* @__PURE__ */ jsx(ColorSquare, {
						color: category.color,
						marginRight: true
					}), category.title] }),
					children: /* @__PURE__ */ jsx(LocationInfoBlocksList, {
						infoBlockCategoryId: category.id,
						locationId
					})
				}, category.id))]
			})
		]
	});
}
//#endregion
export { LocationInfoTabs };

//# sourceMappingURL=LocationInfoTabs.js.map